module.exports = ":host .user-input-label {\n  font-size: 14px;\n  margin-left: 3px;\n  margin-bottom: 3px;\n}\n"